import { GlCard } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import SettingsSection from '~/vue_shared/components/settings/settings_section.vue';
export default {
    name: 'FormSection',
    components: {
        GlCard,
        SettingsSection
    },
    props: {
        title: {
            type: String,
            required: false,
            default: null
        },
        isDisplay: {
            type: Boolean,
            required: false,
            default: false
        }
    }
};
